import HttpService from 'services/HttpService';

import { API_URLS } from 'constants/apiUrls';

import { ClinicianNotification } from 'components/NotificationCenter/types';

const httpService = new HttpService('Notifications', true);

interface GetNotificationsQuery {
  recordsPerPage: number;
  lastNotificationId: number | undefined;
  timestamp?: number;
}

interface UpdateNotificationsParams {
  seen?: number[];
  read?: number[];
  unread?: number[];
}

interface GetNewNotificationsResponse {
  unseenNotifications: number;
}

interface GetUnreadNotificationsResponse {
  unreadNotifications: number;
}

export class NotificationsFetcher {
  static async getNotifications(query: GetNotificationsQuery) {
    return await httpService.get<ClinicianNotification[]>({
      url: API_URLS.NOTIFICATIONS,
      query,
      transformResponse: (notifications) => {
        return notifications.map((notification: ClinicianNotification) => ({
          ...notification,
          createdAt: new Date(notification.createdAt)
        }));
      }
    });
  }

  static async updateNotifications(params: UpdateNotificationsParams) {
    return await httpService.patch({
      url: API_URLS.NOTIFICATIONS,
      data: {
        seen: params.seen || [],
        read: params.read || [],
        unread: params.unread || []
      }
    });
  }

  static async markAllNotificationsAsRead(timestamp: number | null) {
    return await httpService.post({
      url: API_URLS.MARK_ALL_NOTIFICATIONS_READ,
      data: { timestamp }
    });
  }

  static async deleteAllNotifications(timestamp: number | null) {
    return await httpService.post({
      url: API_URLS.DELETE_ALL_NOTIFICATIONS,
      data: { timestamp }
    });
  }
  static async deleteNotification(notificationId: number) {
    return await httpService.put({
      url: `${API_URLS.NOTIFICATIONS}/${notificationId}`
    });
  }

  static async getNewNotificationsNumber() {
    return await httpService.get<GetNewNotificationsResponse>({
      url: API_URLS.CHECK_NEW_NOTIFICATIONS
    });
  }

  static async getUnreadNotificationsNumber() {
    return await httpService.get<GetUnreadNotificationsResponse>({
      url: API_URLS.CHECK_UNREAD_NOTIFICATIONS
    });
  }
}
